import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import routes from '../../routes'
import { appProductName } from '../../appVariant'
import { useOnboardingStore } from '../../stores/useOnboardingStore'
import { getAuthenticatedUsername } from '../../stores/useBootstrapStore'
import { sendToAnalytics } from '../../Analytics'
import { upgradeHintFor } from '../Paywall/paywallCopy'
import ToastCard from '../OnboardingGuide/ToastCard'
import {
    BODY_TEXT,
    GHOST_BUTTON,
    PRIMARY_BUTTON,
    TITLE_TEXT,
    TOAST_FOOTER,
} from '../OnboardingGuide/toastStyles'

// Right after a free account answers the persona question (PersonaToast opens
// it), once: a reminder that paid plans exist, never a gate. Either button
// closes it for good, since only a pick, which never repeats, opens it. The
// guide's first toast waits until it is closed.

function track(action) {
    const data = {
        action,
        persona: useOnboardingStore.getState().persona || 'none',
    }
    try {
        sendToAnalytics({
            userId: getAuthenticatedUsername(),
            event: 'upgrade_reminder',
            data,
        })
        window.posthog?.capture?.('upgrade_reminder', data)
    } catch (ignored) {}
}

export default function UpgradeReminder() {
    const open = useOnboardingStore(state => state.upgradeReminderOpen)
    const closeUpgradeReminder = useOnboardingStore(
        state => state.closeUpgradeReminder
    )
    const navigate = useNavigate()

    React.useEffect(() => {
        if (open) track('shown')
    }, [open])

    if (!open) return null

    const upgrade = () => {
        track('upgrade')
        closeUpgradeReminder()
        const params = new URLSearchParams({
            return: window.location.pathname + window.location.search,
        })
        navigate(`${routes.upgrade}?${params.toString()}`)
    }

    const later = () => {
        track('later')
        closeUpgradeReminder()
    }

    return (
        <ToastCard
            eyebrow="Your plan"
            role="dialog"
            modal
            labelledBy="upgrade-reminder-title"
            testId="upgrade-reminder"
        >
            <p
                id="upgrade-reminder-title"
                className={`tw-m-0 tw-mb-2 ${TITLE_TEXT}`}
            >
                Use {appProductName()} to its full potential
            </p>
            <p className={`tw-m-0 ${BODY_TEXT}`}>
                You’re on the free plan. {upgradeHintFor()}
            </p>
            <div className={`${TOAST_FOOTER} tw-justify-end`}>
                <div className="tw-flex tw-items-center tw-gap-1.5">
                    <button
                        type="button"
                        onClick={later}
                        data-testid="upgrade-reminder-later"
                        className={GHOST_BUTTON}
                    >
                        Maybe later
                    </button>
                    <button
                        type="button"
                        onClick={upgrade}
                        data-testid="upgrade-reminder-upgrade"
                        className={PRIMARY_BUTTON}
                    >
                        Upgrade
                    </button>
                </div>
            </div>
        </ToastCard>
    )
}
